import useApp from "../utils/useApp"

/**
 * @typedef {'rectify-payment' | 'alert' | 'confirm'} Views
 * 
 * @typedef {Object} UseDialog
 * @property {(view: Views, data?: object) => void} open
 * @property {() => void} close
 * @property {boolean} isOpened
 * @property {Views | undefined} currentView
 * @property {object | undefined} data
 * 
 * @returns {UseDialog}
 */
export const useDialog = () => {

    const {
        state: { dialog },
        actions: { setDialog }
    } = useApp()

    const open = (view, data) => setDialog(prev => ({view, data}))
    const close = () => setDialog(prev => null)

    return {
        open, 
        close, 
        isOpened: !!dialog,
        currentView: dialog?.view,
        data: dialog?.data
    }
}